(function($) {

	$('body').on('click', '[data-dropover]', function(e){
        e.preventDefault();
        DropOver( $(this) );
	})
    .on('mouseover', '[data-dropover][data-hover]', function(e){
        e.preventDefault();
        DropOver( $(this) );
    });
    
}(jQuery, window, window.document));


// position dropOver if it has a vertical positioning
function verticalDropOver( trigger, d) {
    var trigLeft = parseInt(trigger.offset().left),
        hOffset = trigger.attr('data-hOffset'),
        vOffset = trigger.attr('data-vOffset'),
        topOffset = parseInt(trigger.offset().top) + parseInt(trigger.height()) + parseInt(vOffset),
        leftOffset;

    hOffset = parseInt(hOffset); // redefine horizontal Offset
        
    if ( d.hasClass('align-right') ) {
        leftOffset = trigLeft + hOffset + parseInt(trigger.width()) - parseInt(d.width());
    } else if ( d.hasClass('align-left') ) {
        leftOffset = trigLeft + hOffset;

    } else {
        leftOffset = trigLeft - parseInt(d.width() / 4);
    }

    d.offset({left: leftOffset, top: topOffset });
}

// position dropOver if it has a horizontal positioning
function horizontalDropOver(trigger, d) {
    var topOffset,
        trigLeft = parseInt(trigger.offset().left),
        hOffset = trigger.attr('data-hOffset'),
        vOffset = trigger.attr('data-vOffset'),
        leftOffset;

    vOffset = parseInt(vOffset);
    hOffset = parseInt(hOffset);

    if ( d.hasClass('align-top') ) {
        topOffset = parseInt( trigger.offset().top ) + vOffset;

    } else if ( d.hasClass('align-bottom') ) {
        topOffset = parseInt(trigger.offset().top) + parseInt(trigger.height()) - parseInt(d.height()) + vOffset;

    } else {
        topOffset = vOffset;
    }

    if ( d.hasClass('left') ) {
        leftOffset = trigLeft - d.width() + hOffset;

    } else if ( d.hasClass('right') ) {
        leftOffset = trigLeft + parseInt(trigger.width()) + hOffset;
    }

    d.offset({top: topOffset, left: leftOffset });
}

function classDropOver( d ) {
     if ( d.hasClass('open') ) {
        d.removeClass('open');
        d.attr('aria-expanded', 'false').attr('aria-hidden', 'true');
    } else {
        d.addClass('open').attr('aria-expanded', 'true').attr('aria-hidden', 'false');
    }
    $(document).click(function(event) { 
        if(!$(event.target).closest('[data-dropover]').length && !$(event.target).closest(d).length ) {
            if(d.hasClass('open')) {
                d.removeClass('open');
            }
        }        
    });
}

function DropOver( el ) {
    var id = '#' + el.attr('data-dropover'),
        position = el.attr('data-position'),
        dropOver = $( id );

    dropOver.addClass( position );

    if ( position == 'top' || position == 'bottom' ) {
        verticalDropOver( el, dropOver );

    } else if ( position == 'left' || position == 'right' ) {
        horizontalDropOver( el, dropOver );
    }
    classDropOver( dropOver );
}